import SuccessIcon from '../../assets/images/success.svg?react';
import { useMutation } from '@tanstack/react-query';
import { FC, useCallback } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';

import { OrderApi } from '../../api';
import { RoutePath } from '../../config';
import { Modal } from '../molecules';

interface Props {
  onClose(): void;
  receiptId?: number;
  address?: number;
  receiptType?: 'receipt' | 'free_form_receipt';
  userRole: string;
}

export const ConfirmOrderModal: FC<Props> = ({
  onClose,
  receiptId,
  address,
  receiptType,
  userRole,
}) => {
  const navigate = useNavigate();

  const { mutate } = useMutation({
    mutationFn: ({
      receiptId,
      address,
      receiptType,
    }: {
      receiptId: number;
      address: number;
      receiptType?: 'receipt' | 'free_form_receipt';
    }) => OrderApi.confirm(receiptId, address, receiptType),
    onSuccess(data) {
      const patientId = data.data.patient_id;

      if (userRole === 'doctor') {
        navigate(
          generatePath(RoutePath.DoctorPatientDetails, {
            patientId: patientId,
          }),
        );
      } else if (userRole === 'patient') {
        navigate(RoutePath.ClientCurrentOrder);
      } else if (
        userRole === 'landing_patient' ||
        userRole === 'landing_user'
      ) {
        navigate(generatePath(RoutePath.Landing, {}));
      }

      onClose();
    },
  });

  const handleConfirmClick = useCallback(() => {
    if (receiptId !== undefined && address !== undefined) {
      mutate({ receiptId, address, receiptType });
    }
  }, [receiptId, address, receiptType, mutate]);

  return (
    <Modal isOpen={Boolean(receiptId)} onClose={onClose}>
      <div className="p-[72px] text-center">
        <span className="flex justify-center">
          <SuccessIcon />
        </span>
        <h2 className="mt-[24px] text-[24px] leading-none">
          Заказ успешно собран!
        </h2>
        <span className="mt-[36px] block">
          Чтобы отправить клиенту, нажмите “подтвердить”{' '}
        </span>
        <footer className="mt-[36px] flex justify-center gap-[24px]">
          <button
            className="button button--outlined px-[40px]"
            onClick={onClose}
            type="button"
          >
            Отменить
          </button>
          <button
            className="button button--primary px-[40px]"
            onClick={handleConfirmClick}
            type="button"
          >
            Подтвердить
          </button>
        </footer>
      </div>
    </Modal>
  );
};
